export function removeAllUnderscores (string) {
  return string.replace(/_/g, '')
}
